import { permissionService } from '@/service/permission';
export interface PermissionData {
  organization: string,
  org_slug: string,
}
export class Permission {
  constructor(private slug: string) {}

  async get(): Promise<PermissionData[] | undefined> {
    try {
      return await permissionService.getAll(this.slug);
    } catch (e) {
      console.warn(e);
    }
  }

  async add(org_slug: string): Promise<PermissionData | undefined> {
    try {
      return await permissionService.add(this.slug, org_slug);
    } catch (e) {
      console.warn(e);
    }
  }

  async delete(org_slug: string): Promise<boolean> {
    try {
      return await permissionService.delete(this.slug, org_slug);
    } catch (e: any) {
      if (e.response?.data?.message) {
        throw new Error(e.response.data.message);
      }
      return false;
    }
  }
}

